import React from 'react';

const icons = {
  wallet: (
    <svg fill="#000000" viewBox="0 0 24 24" id="wallet-money-2" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          id="secondary"
          d="M10.91,4.06,6.74,10H5.58a1,1,0,0,1-.88-.54,1,1,0,0,1,.06-1l3.51-5A1,1,0,0,1,8.91,3a1,1,0,0,1,.75.16Zm8.66,1.56L14.66,2.18a1,1,0,0,0-1.39.25l-1.55,2.2L8,10h9.25A1,1,0,0,0,18,9.57L19.82,7a1,1,0,0,0-.25-1.39Z"
          fill="#1c4c31"
        ></path>
        <rect id="primary" x="2" y="8" width="19" height="14" rx="2" fill="#ddd"></rect>
        <rect id="secondary-2" x="16" y="13" width="6" height="4" rx="1" fill="#1c4c31"></rect>
      </g>
    </svg>
  ),
  clock: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#f77f00" strokeWidth="1.5" />
      <path
        d="M12 8V12L14 14"
        stroke="#f77f00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  facebook: (
    <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.43817 6.461V9.461H3.68817V14.711H6.68817V9.461H8.93817L9.68817 6.461H6.68817V4.961C6.68817 4.76209 6.76719 4.57132 6.90784 4.43067C7.04849 4.29002 7.23926 4.211 7.43817 4.211H9.68817V1.211H7.43817C6.44361 1.211 5.48978 1.60609 4.78652 2.30935C4.08326 3.01261 3.68817 3.96644 3.68817 4.961V6.461H1.43817Z"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  twitter: (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.7272 0.929568C15.9772 1.29707 15.2422 1.44632 14.4772 1.67207C13.6364 0.723318 12.3899 0.670818 11.1922 1.11932C9.99442 1.56782 9.20992 2.66432 9.22717 3.92207V4.67207C6.79342 4.73432 4.62592 3.62582 3.22717 1.67207C3.22717 1.67207 0.0906725 7.24682 6.22717 9.92207C4.82317 10.8573 3.42292 11.4881 1.72717 11.4221C4.20817 12.7743 6.91192 13.2393 9.25267 12.5598C11.9377 11.7798 14.1442 9.76757 14.9909 6.75332C15.2435 5.83657 15.3689 4.88946 15.3637 3.93857C15.3622 3.75182 16.4962 1.85957 16.7272 0.928818V0.929568Z"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  instagram: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.74335 1.711C2.50071 1.711 1.49335 2.71836 1.49335 3.961V9.961C1.49335 11.2036 2.50071 12.211 3.74335 12.211H9.74335C10.986 12.211 11.9933 11.2036 11.9933 9.961V3.961C11.9933 2.71836 10.986 1.711 9.74335 1.711H3.74335ZM-0.00665283 3.961C-0.00665283 1.88993 1.67228 0.210999 3.74335 0.210999H9.74335C11.8144 0.210999 13.4933 1.88993 13.4933 3.961V9.961C13.4933 12.0321 11.8144 13.711 9.74335 13.711H3.74335C1.67228 13.711 -0.00665283 12.0321 -0.00665283 9.961V3.961ZM6.74335 5.461C5.91492 5.461 5.24335 6.13257 5.24335 6.961C5.24335 7.78943 5.91492 8.461 6.74335 8.461C7.57178 8.461 8.24335 7.78943 8.24335 6.961C8.24335 6.13257 7.57178 5.461 6.74335 5.461ZM3.74335 6.961C3.74335 5.30414 5.08649 3.961 6.74335 3.961C8.4002 3.961 9.74335 5.30414 9.74335 6.961C9.74335 8.61785 8.4002 9.961 6.74335 9.961C5.08649 9.961 3.74335 8.61785 3.74335 6.961ZM10.8683 3.586C10.8683 3.17179 10.5326 2.836 10.1183 2.836C9.70413 2.836 9.36835 3.17179 9.36835 3.586V3.58675C9.36835 4.00096 9.70413 4.33675 10.1183 4.33675C10.5326 4.33675 10.8683 4.00096 10.8683 3.58675V3.586Z"
        fill="#121212"
      />
    </svg>
  ),
  linkedin: (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.73438 12.6904V4.51465H0.191406V12.6904H2.73438ZM1.44922 3.4209C2.26953 3.4209 2.92578 2.7373 2.92578 1.91699C2.92578 1.12402 2.26953 0.467773 1.44922 0.467773C0.65625 0.467773 0 1.12402 0 1.91699C0 2.7373 0.65625 3.4209 1.44922 3.4209ZM12.2227 12.6904H12.25V8.20605C12.25 6.01855 11.7578 4.32324 9.1875 4.32324C7.95703 4.32324 7.13672 5.00684 6.78125 5.63574H6.75391V4.51465H4.32031V12.6904H6.86328V8.64355C6.86328 7.57715 7.05469 6.56543 8.36719 6.56543C9.67969 6.56543 9.70703 7.76855 9.70703 8.72559V12.6904H12.2227Z"
        fill="#051036"
      />
    </svg>
  ),
  menu: (
    <svg
      width="10px"
      height="10px"
      viewBox="-6.5 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs></defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="#000000" fillRule="evenodd">
        <g id="Dribbble-Light-Preview" transform="translate(-306.000000, -800.000000)">
          <g id="icons" transform="translate(56.000000, 160.000000)">
            <path
              d="M253.5,658 C252.857167,658 252.333333,657.551 252.333333,657 C252.333333,656.449 252.857167,656 253.5,656 C254.142833,656 254.666667,656.449 254.666667,657 C254.666667,657.551 254.142833,658 253.5,658 M253.5,654 C251.566833,654 250,655.343 250,657 C250,658.657 251.566833,660 253.5,660 C255.433167,660 257,658.657 257,657 C257,655.343 255.433167,654 253.5,654 M253.5,651 C252.857167,651 252.333333,650.551 252.333333,650 C252.333333,649.449 252.857167,649 253.5,649 C254.142833,649 254.666667,649.449 254.666667,650 C254.666667,650.551 254.142833,651 253.5,651 M253.5,647 C251.566833,647 250,648.343 250,650 C250,651.657 251.566833,653 253.5,653 C255.433167,653 257,651.657 257,650 C257,648.343 255.433167,647 253.5,647 M253.5,642 C254.142833,642 254.666667,642.449 254.666667,643 C254.666667,643.551 254.142833,644 253.5,644 C252.857167,644 252.333333,643.551 252.333333,643 C252.333333,642.449 252.857167,642 253.5,642 M253.5,646 C255.433167,646 257,644.657 257,643 C257,641.343 255.433167,640 253.5,640 C251.566833,640 250,641.343 250,643 C250,644.657 251.566833,646 253.5,646"
              id="menu_option-[#1374]"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  downAngle: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M16.6402 8.26824L10.6402 13.2682C9.61589 14.1218 8.33552 12.5854 9.35982 11.7318L15.3598 6.7318C16.3841 5.87822 17.6645 7.41466 16.6402 8.26824Z"
          fill="#000000"
        ></path>{' '}
        <path
          d="M4.64019 6.7318L10.6402 11.7318C11.6645 12.5854 10.3841 14.1218 9.35982 13.2682L3.35982 8.26824C2.33552 7.41466 3.61589 5.87822 4.64019 6.7318Z"
          fill="#000000"
        ></path>{' '}
      </g>
    </svg>
  ),
  search: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        strokeWidth={1.5}
        d="m16.893 16.92 3.08 3.08m-.889-8.419c0 4.187-3.383 7.581-7.555 7.581-4.173 0-7.556-3.394-7.556-7.58C3.973 7.393 7.356 4 11.528 4c4.173 0 7.556 3.394 7.556 7.581"
      />
    </svg>
  ),
  favorite: (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8791 8.88915L9.0077 15.5L2.13626 8.88915M2.13626 8.88915C1.68302 8.46072 1.32601 7.94577 1.08772 7.37673C0.849422 6.80769 0.734997 6.19689 0.75165 5.58278C0.768302 4.96867 0.915671 4.36456 1.18448 3.8085C1.45328 3.25243 1.8377 2.75645 2.31353 2.3518C2.78935 1.94714 3.34628 1.64257 3.94923 1.45727C4.55218 1.27197 5.1881 1.20994 5.81694 1.27511C6.44578 1.34027 7.05392 1.53121 7.60306 1.83589C8.1522 2.14058 8.63045 2.55242 9.0077 3.04547C9.38657 2.556 9.86538 2.14776 10.4141 1.8463C10.9629 1.54485 11.5698 1.35667 12.1969 1.29354C12.824 1.23042 13.4577 1.2937 14.0585 1.47944C14.6592 1.66517 15.214 1.96936 15.6882 2.37296C16.1623 2.77657 16.5456 3.27089 16.814 3.82501C17.0825 4.37912 17.2303 4.9811 17.2482 5.59326C17.2661 6.20541 17.1538 6.81458 16.9182 7.38262C16.6826 7.95066 16.3289 8.46536 15.8791 8.89449"
        fill="#1c4c31"
      />
      <path
        d="M15.8791 8.88915L9.0077 15.5L2.13626 8.88915M2.13626 8.88915C1.68302 8.46072 1.32601 7.94577 1.08772 7.37673C0.849422 6.80769 0.734997 6.19689 0.75165 5.58278C0.768302 4.96867 0.915671 4.36456 1.18448 3.8085C1.45328 3.25243 1.8377 2.75645 2.31353 2.3518C2.78935 1.94714 3.34628 1.64257 3.94923 1.45727C4.55218 1.27197 5.1881 1.20994 5.81694 1.27511C6.44578 1.34027 7.05392 1.53121 7.60306 1.83589C8.1522 2.14058 8.63045 2.55242 9.0077 3.04547C9.38657 2.556 9.86538 2.14776 10.4141 1.8463C10.9629 1.54485 11.5698 1.35667 12.1969 1.29354C12.824 1.23042 13.4577 1.2937 14.0585 1.47944C14.6592 1.66517 15.214 1.96936 15.6882 2.37296C16.1623 2.77657 16.5456 3.27089 16.814 3.82501C17.0825 4.37912 17.2303 4.9811 17.2482 5.59326C17.2661 6.20541 17.1538 6.81458 16.9182 7.38262C16.6826 7.95066 16.3289 8.46536 15.8791 8.89449"
        stroke="#1c4c31"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  unfavorite: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        strokeWidth={1.5}
        d="M7.75 3.5C5.127 3.5 3 5.76 3 8.547 3 14.125 12 20.5 12 20.5s9-6.375 9-11.953C21 5.094 18.873 3.5 16.25 3.5c-1.86 0-3.47 1.136-4.25 2.79-.78-1.654-2.39-2.79-4.25-2.79"
      />
    </svg>
  ),
  email: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24" fill="none">
      <path
        d="M21 4.5H3a1.5 1.5 0 0 0 -1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h18a1.5 1.5 0 0 0 1.5 -1.5V6a1.5 1.5 0 0 0 -1.5 -1.5Zm-1.6500000000000001 1.5L12 11.084999999999999 4.65 6ZM3 18V6.6825l8.5725 5.9325a0.75 0.75 0 0 0 0.855 0L21 6.6825V18Z"
        fill="#000000"
        strokeWidth="0.75"
      ></path>
    </svg>
  ),
  user: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
    >
      <path
        stroke="#000"
        strokeWidth={1.5}
        d="M8 6a4 4 0 1 0 8 0 4 4 0 1 0-8 0M5 17a7 4 0 1 0 14 0 7 4 0 1 0-14 0"
      />
    </svg>
  ),
  cart: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        strokeWidth={1.5}
        d="M8.935 7H7.773c-1.072 0-1.962.81-2.038 1.858l-.73 10C4.921 20.015 5.858 21 7.043 21h9.914c1.185 0 2.122-.985 2.038-2.142l-.73-10C18.189 7.81 17.299 7 16.227 7h-1.162m-6.13 0V5c0-1.105.915-2 2.043-2h2.044c1.128 0 2.043.895 2.043 2v2m-6.13 0h6.13"
      />
    </svg>
  ),
  rightArrow: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 12H19"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 18L19 12"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 6L19 12"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  sliderLeftArrow: (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 5H11.25" stroke="#121212" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M0.75 5L5.25 9.5" stroke="#121212" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M0.75 5L5.25 0.5" stroke="#121212" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),

  sliderRightArrow: (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 5H11.25" stroke="#121212" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.75 9.5L11.25 5" stroke="#121212" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.75 0.5L11.25 5" stroke="#121212" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  closeIcon: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7071 8.70711C25.0976 8.31658 25.0976 7.68342 24.7071 7.29289C24.3166 6.90237 23.6834 6.90237 23.2929 7.29289L16 14.5858L8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L14.5858 16L7.29289 23.2929C6.90237 23.6834 6.90237 24.3166 7.29289 24.7071C7.68342 25.0976 8.31658 25.0976 8.70711 24.7071L16 17.4142L23.2929 24.7071C23.6834 25.0976 24.3166 25.0976 24.7071 24.7071C25.0976 24.3166 25.0976 23.6834 24.7071 23.2929L17.4142 16L24.7071 8.70711Z"
        fill="#121212"
      />
    </svg>
  ),
  accountInbox: (
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.5 6.5h17v11h-17z" />
      <path d="m3.5 7.5 8.5 5.8 8.5-5.8" />
    </svg>
  ),
  accountListings: (
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4h6.3L20 13.7a1.6 1.6 0 0 1 0 2.3l-4 4a1.6 1.6 0 0 1-2.3 0L4 10.3z" />
      <circle cx="8.6" cy="8.6" r="1.2" />
    </svg>
  ),
  accountSettings: (
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.2 2.2M16.2 16.2l2.2 2.2M18.4 5.6l-2.2 2.2M7.8 16.2l-2.2 2.2" />
    </svg>
  ),
  accountLogout: (
    <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 4H5.5v16H9" />
      <path d="m14 8 4 4-4 4" />
      <path d="M18 12H9.5" />
    </svg>
  ),
  bottomSearch: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
      <path strokeWidth="1.5" d="m16.893 16.92 3.08 3.08m-.889-8.419c0 4.187-3.383 7.581-7.555 7.581-4.173 0-7.556-3.394-7.556-7.58C3.973 7.393 7.356 4 11.528 4c4.173 0 7.556 3.394 7.556 7.581" />
    </svg>
  ),
  bottomBrowse: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 8.5h16M4 15.5h16" />
    </svg>
  ),
  bottomSell: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v8M8 12h8" />
    </svg>
  ),
  bottomAccount: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" strokeWidth="1.5" d="M8 6a4 4 0 1 0 8 0 4 4 0 1 0-8 0M5 17a7 4 0 1 0 14 0 7 4 0 1 0-14 0" />
    </svg>
  ),
  sortArrows: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#121212"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 4v16M7 4L3.5 7.5M7 4l3.5 3.5M17 20V4m0 16l3.5-3.5M17 20l-3.5-3.5" />
    </svg>
  ),
  suggestionArrow: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#1c4c31"
      strokeWidth="2"
      strokeLinecap="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 17L17 7M9 7h8v8" />
    </svg>
  ),
  navSearch: (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.31714 11.0635C5.31714 7.95203 7.83948 5.42969 10.951 5.42969C14.0624 5.42969 16.5848 7.95203 16.5848 11.0635C16.5848 14.175 14.0624 16.6973 10.951 16.6973C7.83948 16.6973 5.31714 14.175 5.31714 11.0635ZM10.951 3.92969C7.01106 3.92969 3.81714 7.12361 3.81714 11.0635C3.81714 15.0034 7.01106 18.1973 10.951 18.1973C12.6508 18.1973 14.2117 17.6028 15.4372 16.6104L20.4523 21.6255C20.7452 21.9184 21.2201 21.9184 21.513 21.6255C21.8059 21.3327 21.8059 20.8578 21.513 20.5649L16.4979 15.5498C17.4903 14.3242 18.0848 12.7633 18.0848 11.0635C18.0848 7.12361 14.8909 3.92969 10.951 3.92969Z"
        fill="#121212"
      />
    </svg>
  ),
  navFavourites: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.8791 12.8892L12.0076 19.5L5.13619 12.8892M5.13619 12.8892C4.68296 12.4607 4.32595 11.9458 4.08766 11.3767C3.84936 10.8077 3.73494 10.1969 3.75159 9.58278C3.76824 8.96867 3.91561 8.36456 4.18442 7.8085C4.45322 7.25243 4.83764 6.75645 5.31347 6.3518C5.78929 5.94714 6.34621 5.64257 6.94917 5.45727C7.55212 5.27197 8.18804 5.20994 8.81688 5.27511C9.44572 5.34027 10.0539 5.53121 10.603 5.83589C11.1521 6.14058 11.6304 6.55242 12.0076 7.04547C12.3865 6.556 12.8653 6.14776 13.4141 5.8463C13.9628 5.54485 14.5698 5.35667 15.1968 5.29354C15.8239 5.23042 16.4577 5.2937 17.0584 5.47944C17.6591 5.66517 18.2139 5.96936 18.6881 6.37296C19.1622 6.77657 19.5455 7.27089 19.814 7.82501C20.0824 8.37912 20.2302 8.9811 20.2481 9.59326C20.2661 10.2054 20.1537 10.8146 19.9182 11.3826C19.6826 11.9507 19.3288 12.4654 18.8791 12.8945"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // Outline house, drawn like the other nav icons (24 grid, 1.5 stroke)
  navHome: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 10.25 12 4l8 6.25V19a1 1 0 0 1-1 1h-4.5v-5.5h-5V20H5a1 1 0 0 1-1-1z" />
    </svg>
  ),
  cross: (
    <svg width="16" height="16" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.39775 1.89775C8.61742 1.67808 8.61742 1.32192 8.39775 1.10225C8.17808 0.882583 7.82192 0.882583 7.60225 1.10225L4.5 4.2045L1.39775 1.10225C1.17808 0.882583 0.821922 0.882583 0.602252 1.10225C0.382583 1.32192 0.382583 1.67808 0.602252 1.89775L3.7045 5L0.602252 8.10225C0.382583 8.32192 0.382583 8.67808 0.602252 8.89775C0.821922 9.11742 1.17808 9.11742 1.39775 8.89775L4.5 5.79549L7.60225 8.89775C7.82192 9.11742 8.17808 9.11742 8.39775 8.89775C8.61742 8.67808 8.61742 8.32192 8.39775 8.10225L5.29549 5L8.39775 1.89775Z"
        fill="#121212"
      />
    </svg>
  ),
  eye: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M22 12C19.333 16.667 16 19 12 19C8 19 4.667 16.667 2 12C4.667 7.333 8 5 12 5C16 5 19.333 7.333 22 12Z"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  filter: (
    <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.41666 3.45817C8.41666 2.60673 9.10689 1.9165 9.95833 1.9165C10.8098 1.9165 11.5 2.60673 11.5 3.45817C11.5 4.30961 10.8098 4.99984 9.95833 4.99984C9.10689 4.99984 8.41666 4.30961 8.41666 3.45817ZM7.00983 4.20817C7.34385 5.52534 8.53729 6.49984 9.95833 6.49984C11.3794 6.49984 12.5728 5.52534 12.9068 4.20817H16C16.4142 4.20817 16.75 3.87238 16.75 3.45817C16.75 3.04396 16.4142 2.70817 16 2.70817H12.9068C12.5728 1.391 11.3794 0.416504 9.95833 0.416504C8.53729 0.416504 7.34385 1.391 7.00983 2.70817H1C0.585786 2.70817 0.25 3.04396 0.25 3.45817C0.25 3.87238 0.585786 4.20817 1 4.20817H7.00983ZM3.41667 10.1248C3.41667 9.27339 4.10689 8.58317 4.95833 8.58317C5.80977 8.58317 6.5 9.27339 6.5 10.1248C6.5 10.9763 5.80977 11.6665 4.95833 11.6665C4.10689 11.6665 3.41667 10.9763 3.41667 10.1248ZM4.95833 13.1665C3.53729 13.1665 2.34385 12.192 2.00983 10.8748H1C0.585786 10.8748 0.25 10.539 0.25 10.1248C0.25 9.71062 0.585786 9.37483 1 9.37483H2.00983C2.34385 8.05766 3.53729 7.08317 4.95833 7.08317C6.37937 7.08317 7.57281 8.05766 7.90683 9.37483H16C16.4142 9.37483 16.75 9.71062 16.75 10.1248C16.75 10.539 16.4142 10.8748 16 10.8748H7.90683C7.57281 12.192 6.37937 13.1665 4.95833 13.1665Z"
        fill="#121212"
      />
    </svg>
  ),

  bin: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M9.17 4a3.001 3.001 0 0 1 5.66 0M20.5 6h-17M18.833 8.5l-.46 6.9c-.177 2.654-.265 3.982-1.13 4.79-.865.81-2.196.81-4.856.81h-.774c-2.66 0-3.99 0-4.856-.81-.865-.809-.953-2.136-1.13-4.79l-.46-6.9M9.5 11l.5 5M14.5 11l-.5 5"
      />
    </svg>
  ),
  share: (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2402 2.16357C12.2737 2.16357 11.4902 2.94708 11.4902 3.91357C11.4902 4.16506 11.5433 4.40415 11.6388 4.62027C11.6451 4.63111 11.6511 4.64217 11.6569 4.65343C11.6689 4.67677 11.6796 4.70045 11.689 4.72439C11.9814 5.28266 12.5663 5.66357 13.2402 5.66357C14.2067 5.66357 14.9902 4.88007 14.9902 3.91357C14.9902 2.94708 14.2067 2.16357 13.2402 2.16357ZM9.99023 3.91357C9.99023 4.15895 10.0174 4.39797 10.069 4.6278L5.75239 6.85149C5.15633 6.12618 4.25231 5.66357 3.24023 5.66357C1.44531 5.66357 -0.00976562 7.11865 -0.00976562 8.91357C-0.00976562 10.7085 1.44531 12.1636 3.24023 12.1636C4.25231 12.1636 5.15634 11.7009 5.7524 10.9756L10.069 13.1993C10.0174 13.4292 9.99023 13.6682 9.99023 13.9136C9.99023 15.7085 11.4453 17.1636 13.2402 17.1636C15.0352 17.1636 16.4902 15.7085 16.4902 13.9136C16.4902 12.1186 15.0352 10.6636 13.2402 10.6636C12.2281 10.6636 11.3241 11.1262 10.728 11.8515L6.41149 9.62783C6.46304 9.398 6.49023 9.15896 6.49023 8.91357C6.49023 8.66817 6.46303 8.42913 6.41149 8.19929L10.728 5.97561C11.3241 6.70094 12.2281 7.16357 13.2402 7.16357C15.0352 7.16357 16.4902 5.7085 16.4902 3.91357C16.4902 2.11865 15.0352 0.663574 13.2402 0.663574C11.4453 0.663574 9.99023 2.11865 9.99023 3.91357ZM4.84193 9.61969C4.93728 9.40372 4.99023 9.16483 4.99023 8.91357C4.99023 8.66228 4.93727 8.42335 4.84189 8.20736C4.8355 8.19635 4.82935 8.18513 4.82346 8.17369C4.81135 8.15018 4.8006 8.12632 4.79118 8.10221C4.49869 7.54424 3.91391 7.16357 3.24023 7.16357C2.27374 7.16357 1.49023 7.94707 1.49023 8.91357C1.49023 9.88007 2.27374 10.6636 3.24023 10.6636C3.91389 10.6636 4.49864 10.2829 4.79115 9.72499C4.80057 9.70085 4.81133 9.67697 4.82346 9.65342C4.82936 9.64196 4.83553 9.63072 4.84193 9.61969ZM11.6388 13.2068C11.6451 13.196 11.6511 13.1849 11.6569 13.1737C11.6689 13.1504 11.6796 13.1267 11.689 13.1028C11.9814 12.5445 12.5663 12.1636 13.2402 12.1636C14.2067 12.1636 14.9902 12.9471 14.9902 13.9136C14.9902 14.8801 14.2067 15.6636 13.2402 15.6636C12.2737 15.6636 11.4902 14.8801 11.4902 13.9136C11.4902 13.6621 11.5433 13.4229 11.6388 13.2068Z"
        fill="#121212"
      />
    </svg>
  ),
  question: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.81347 2.20654C5.08555 2.20654 2.06348 5.22862 2.06348 8.95654C2.06348 12.6845 5.08555 15.7065 8.81347 15.7065C12.5414 15.7065 15.5635 12.6845 15.5635 8.95654C15.5635 5.22862 12.5414 2.20654 8.81347 2.20654ZM0.563477 8.95654C0.563477 4.40019 4.25713 0.706543 8.81347 0.706543C13.3698 0.706543 17.0635 4.40019 17.0635 8.95654C17.0635 13.5129 13.3698 17.2065 8.81347 17.2065C4.25713 17.2065 0.563477 13.5129 0.563477 8.95654ZM8.81347 12.3732C9.22769 12.3732 9.56347 12.709 9.56347 13.1232V13.1316C9.56347 13.5458 9.22769 13.8816 8.81347 13.8816C8.39926 13.8816 8.06347 13.5458 8.06347 13.1316V13.1232C8.06347 12.709 8.39926 12.3732 8.81347 12.3732ZM8.88099 4.01618C8.42956 4.01493 7.984 4.11848 7.57939 4.31869C7.17478 4.51889 6.82217 4.81028 6.54931 5.16992C6.29895 5.49991 6.3635 5.97038 6.69349 6.22074C7.02347 6.4711 7.49394 6.40655 7.7443 6.07656C7.87683 5.90188 8.0481 5.76035 8.24463 5.66311C8.44115 5.56587 8.65756 5.51557 8.87683 5.51618C9.0961 5.51679 9.31223 5.56828 9.50821 5.66661C9.70419 5.76494 9.87467 5.90743 10.0062 6.08284C10.1378 6.25825 10.2268 6.46181 10.2664 6.67748C10.3059 6.89316 10.2948 7.11506 10.234 7.32573C10.1732 7.5364 10.0643 7.73007 9.91592 7.89151C9.76933 8.05099 9.58815 8.17471 9.38632 8.2532C8.98233 8.39807 8.63555 8.66911 8.39737 9.02639C8.15688 9.38711 8.04013 9.81621 8.06468 10.249C8.08813 10.6626 8.44239 10.9788 8.85594 10.9554C9.26949 10.9319 9.58572 10.5777 9.56227 10.1641C9.55613 10.0559 9.58532 9.94862 9.64544 9.85844C9.70556 9.76826 9.79336 9.70006 9.8956 9.66411L9.9147 9.6571C10.3363 9.49585 10.7148 9.23893 11.0203 8.90657C11.3258 8.5742 11.55 8.17546 11.6752 7.74173C11.8004 7.30801 11.8232 6.85115 11.7418 6.40711C11.6604 5.96307 11.4771 5.54398 11.2062 5.18284C10.9354 4.82169 10.5844 4.52835 10.1809 4.3259C9.7774 4.12346 9.33242 4.01744 8.88099 4.01618Z"
        fill="#121212"
      />
    </svg>
  ),
  check: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12l5 5l10-10" />
    </svg>
  ),
  xMark: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 6l-12 12" />
      <path d="M6 6l12 12" />
    </svg>
  ),
  shieldCheck: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11.46 20.846a12 12 0 0 1-7.96-14.846a12 12 0 0 0 8.5-3a12 12 0 0 0 8.5 3a12 12 0 0 1-.09 7.06" />
      <path d="M15 19l2 2l4-4" />
    </svg>
  ),
  calendarCheck: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11.5 21H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6" />
      <path d="M16 3v4" />
      <path d="M8 3v4" />
      <path d="M4 11h16" />
      <path d="M15 19l2 2l4-4" />
    </svg>
  ),
  photoOff: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 8h.01" />
      <path d="M7 3h11a3 3 0 0 1 3 3v11m-.856 3.099A2.991 2.991 0 0 1 18 21H6a3 3 0 0 1-3-3V6c0-.71.248-1.363.66-1.878" />
      <path d="M3 3l18 18" />
      <path d="M3 16l5-5c.928-.893 2.072-.893 3 0l5 5" />
      <path d="M14 14l1-1c.617-.593 1.328-.793 2.009-.598" />
    </svg>
  ),
  rotate2: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 4.55a8 8 0 0 0-6 14.9m0-4.45v5h-5" />
      <path d="M18.37 7.16l0 .01" />
      <path d="M13 19.94l0 .01" />
      <path d="M16.84 18.37l0 .01" />
      <path d="M19.37 15.1l0 .01" />
      <path d="M19.94 11l0 .01" />
    </svg>
  ),
  userCheck: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0-8 0" />
      <path d="M6 21v-2a4 4 0 0 1 4-4h4" />
      <path d="M15 19l2 2l4-4" />
    </svg>
  ),
  cashBanknoteMove: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0-6 0" />
      <path d="M12 18h-7a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4.5" />
      <path d="M18 12h.01" />
      <path d="M6 12h.01" />
      <path d="M16 19h6" />
      <path d="M19 16l3 3l-3 3" />
    </svg>
  ),
  scale: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 20l10 0" />
      <path d="M6 6l6-1l6 1" />
      <path d="M12 3l0 17" />
      <path d="M9 12l-3-6l-3 6a3 3 0 0 0 6 0" />
      <path d="M21 12l-3-6l-3 6a3 3 0 0 0 6 0" />
    </svg>
  ),
  messages: (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 14l-3-3h-7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v10" />
      <path d="M14 15v2a1 1 0 0 1-1 1h-7l-3 3v-10a1 1 0 0 1 1-1h2" />
    </svg>
  ),
};

const Icons = ({ name, className }) => {
  const icon = icons[name];
  if (!icon) return null;
  if (className) {
    return React.cloneElement(icon, { className });
  }
  return icon;
};

export default Icons;
